import React from "react";
import ReactivePopupContent from "./ReactivePopupContent";
import MapPopupShell from "./MapPopupShell";
import { ApiEndpoint } from "../../../types";

// This MapPopup component is a wrapper for the ReactivePopupContent component.
// This is derived from the MapComponent component which is split into its own component for reusability and maintainability

export interface MapPopupData {
  entityId: string | number;
  entityName: string;
  endpoint: ApiEndpoint;
  coordinates: [number, number];
}

interface Props {
  popupData: MapPopupData | null;
  open: boolean;
  onClose: () => void;
}

const MapPopup: React.FC<Props> = ({ popupData, open, onClose }) => {
  if (!open || !popupData) return null;

  return (
    <MapPopupShell popupKey={`popup-${popupData.entityId}`} coordinates={popupData.coordinates} onClose={onClose}>
      <ReactivePopupContent
        entityId={popupData.entityId}
        entityName={popupData.entityName}
        endpoint={popupData.endpoint}
        onBack={onClose}
      />
    </MapPopupShell>
  );
};

export default React.memo(MapPopup);
